module.exports = __webpack_public_path__ + "img/COVER.8586c776.jpg";